import axios, { AxiosResponse } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function DataDeletionPageRider() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submissionStatus, setSubmissionStatus] = useState<null | 'success' | 'error'>(null);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {
      const data = { email, message };
      const response: AxiosResponse<any, any> = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/request-exclude-rider`,
        data
      );

      if (response.data) {
        setSubmissionStatus('success');
        setEmail('');
        setMessage('');
      }

      setTimeout(() => setSubmissionStatus(null), 5000);
    } catch (error) {
      setSubmissionStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <h1 className="text-3xl font-bold text-primary mb-8 text-center">
            {t('requestExclude.request')}
          </h1>

          {submissionStatus === 'success' && (
            <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg">
              {t('requestExclude.receivedRequest')}
            </div>
          )}

          {submissionStatus === 'error' && (
            <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-lg">
              {t('requestExclude.error')}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                {t('requestExclude.emailLabel')}
              </label>
              <input
                type="email"
                id="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder={t('requestExclude.emailPlaceholder')}
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                {t('requestExclude.messageLabel')}
              </label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 h-32"
                placeholder={t('requestExclude.messagePlaceholder')}
              />
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="w-full sm:w-auto px-6 py-3 bg-primary text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                disabled={!email}
              >
                {t('requestExclude.submitButton')}
              </button>
            </div>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-[11px] font-medium text-green-700">
              LGPD · Art. 18 — Direito de Eliminação
            </span>
            <a href="mailto:dpo@trusom.com" className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-[11px] font-medium text-blue-700 hover:underline">
              Encarregado (DPO): dpo@trusom.com
            </a>
            <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-[11px] font-medium text-gray-600">
              🔒 Conexão segura
            </span>
          </div>
          <div className="mt-4 text-sm text-gray-500">
            <p>{t('requestExclude.lgpdNotice')}</p>
            <p className="mt-2">
              {t('requestExclude.privacyPolicyText')}{' '}
              <a href="/privacy-policy-rider" className="text-blue-600 hover:underline">
                {t('requestExclude.privacyPolicyLink')}
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
